import React from "react";
import SecondTabNavigation from "./SecondTabNavigation";


const SecondTab = ({ tabConfig }) => {
  return (
    <div
      style={{
        backgroundColor: "#fff",
        borderBottom: "1px solid #e9ecef",
        padding: "0",
      }}
    >
      <SecondTabNavigation tabConfig={tabConfig} />
    </div>
  );
};

export default SecondTab;
